export let EditShapeStatus;(function(t){t["IN_PROGRESS"]="in_progress";t["FINISHED"]="finished"})(EditShapeStatus||(EditShapeStatus={}));